import {type EngagementReport} from '../types/EngagementReport';

export type EngagementBeaconBody = EngagementReport & {
  sessionId: string;
};

/**
 * navigator.sendBeacon cannot set the X-Workspace header, so the tenant travels
 * via the `x-workspace` query parameter (supported backend-wide).
 */
export const buildEngagementBeaconRequest = (args: {
  endpointUrl: string;
  workspace: string;
  body: EngagementBeaconBody;
}) => ({
  url: `${args.endpointUrl}?x-workspace=${encodeURIComponent(args.workspace)}`,
  blob: new Blob([JSON.stringify(args.body)], {type: 'application/json'}),
});
